import { render, staticRenderFns } from "./ConsistencyType.vue?vue&type=template&id=48b0e951"
import script from "./ConsistencyType.vue?vue&type=script&lang=js"
export * from "./ConsistencyType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b0e951')) {
      api.createRecord('48b0e951', component.options)
    } else {
      api.reload('48b0e951', component.options)
    }
    module.hot.accept("./ConsistencyType.vue?vue&type=template&id=48b0e951", function () {
      api.rerender('48b0e951', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/ConsistencyType.vue"
export default component.exports